import React, { useEffect } from "react";
import CommonView, { CommonViewProps } from "../../../components/CommonView/CommonView";
import { MasterConfigs } from "../../../interfaces/entity";
import MasterComponent from "../../../components/Forms";
import { Button, Space, Typography } from "antd";
import CustomModal from "../../../components/custom/Modal";
import ParseCsv from "../../../components/CSV/ParseCsv";
import { postData } from "../../../actions/developer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ProfileCard from "../../../components/ContactInfo/ProfileCard";
const { Title, Text } = Typography;

const MCQQuestions = () => {
    const [refresh, setRefresh] = React.useState(false)
    const [selectedId, setSelectedId] = React.useState(null);
    const [options, setOptions] = React.useState(null);
    const [importModel, setImportModel] = React.useState(false);
    const [data, setData] = React.useState<any[]>([]);
    const dispatch = useDispatch();
    const { user } = useSelector((state: any) => state.app);

    const [sampleData, setSampleData] = React.useState<any>([
        ['Sr', 'skills', 'question', 'Option1', 'Option2', 'Option3', 'Option4', 'correctAnswer'],
        [1, '', "What is the capital of India?", "Mumbai", "Delhi", "Kolkata", "Chennai", "Delhi"],
    ]);

    useEffect(() => {
        if (selectedId) {
            const arr = sampleData[1].map((item, index) => {
                if (index === 1) {
                    return selectedId
                } else {
                    return item
                }
            });
            const sample_data = [
                sampleData[0],
                arr
            ]
            setSampleData(sample_data)
        }
    }, [selectedId])

    const config: MasterConfigs = {
        api: () => '/skills',
        modalTitle: () => 'Skills',
        onRefresh: () => {
            setRefresh(true)
        },
        getFormColumns: () => [
            {
                label: 'Skill Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Skill name' }]
            },
            {
                label: 'Short Code',
                name: 'shortCode',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Short Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16,
            },
        ],
    }

    const McqQuestionConfig: MasterConfigs = {
        api: () => '/mcq-questions',
        apiParams: { skills: selectedId },
        queryParams: { skills: selectedId },
        onDataLoad: (data) => {
            if (data?.options.length > 0) {
                setOptions(data?.options)
            }
        },
        modalTitle: () => 'MCQ Questions',
        onRefresh: () => {
            setOptions(null)
        },
        handleValuesChange: (value, values) => {
            setTimeout(() => {
                if (values?.options.length > 0) {
                    setOptions(values?.options)
                }
            }, 1000)
        },
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Question',
                dataIndex: 'question',
                key: 'question',
                ellipsis: true
            },
            {
                title: 'Options',
                dataIndex: 'options',
                key: 'options',
                ellipsis: true,
                render: (options) => {
                    return options.map((item, index) => {
                        return <div key={index}>{String.fromCharCode(65 + index) + ") "}{item.option}</div>
                    })
                }
            },
            {
                title: 'Answer',
                dataIndex: 'correctAnswer',
                key: 'correctAnswer',
                ellipsis: true
            },
        ],
        getFormColumns: () => [
            {
                label: 'Question',
                name: 'question',
                type: 'textarea',
                span: 16,
                rules: [{ required: true, message: 'Please enter Question' }]
            },
            {
                type: 'custom',
                formItem: () => <Title level={5}>Options</Title>,
                span: 24
            },
            {
                name: 'options',
                type: 'form',
                span: 16,
                form: [{
                    label: 'Option',
                    name: 'option',
                    type: 'text',
                    rules: [{ required: true, message: 'Please enter Option value' }]
                }],
            },
            {
                span: 8
            },
            {
                label: 'Answer',
                name: 'correctAnswer',
                type: 'select',
                children: options?.map((item, index) => ({ name: item?.option, value: item?.option })),
                rules: [{ required: true, message: 'Please select Answer' }]
            },
        ],
        actions: [
            { actionType: 'Add', name: 'Add' }
        ],
        extraControles: [
            <Button type="primary" onClick={() => setImportModel(true)}>Import</Button>
        ]
    }

    const componentConfig: CommonViewProps = {
        config: config,
        listProps: {
            reload: refresh,
            onLoaded: () => {
                setRefresh(false)
            }
        },
        componentConfig: {
            title: "MCQ Questions",
            subTitle: "MCQ Questions",
            cardTitle: "MCQ Questions",
            buttonName: "Add Question",
            emptyDescription: "No MCQ Questions found",
            renderComponent: (record: any) => <MasterComponent config={McqQuestionConfig} />,
            renderListItem: (record: any) => record.name,
            selectedItemId: (id) => setSelectedId(id),
        }
    }

    const reloadTable = () => {
        dispatch({
            type: 'REFRESH_TABLE',
            refreshTable: true,
        })
    }

    const validateData = (data) => {
        const validData = data.filter((item) => {
            if (item.question && item.Option1 && item.Option2 && item.Option3 && item.Option4 && item.correctAnswer) {
                return item
            }
        })
        return validData
    }

    const onSubmit = async () => {
        if (data.length === 0) {
            return
        }
        const validate = validateData(data);
        if (validate.length === 0) {
            return
        }
        const payload = data.map((item, index) => {
            return {
                skills: selectedId,
                correctAnswer: item.correctAnswer,
                options: [
                    { option: item.Option1 },
                    { option: item.Option2 },
                    { option: item.Option3 },
                    { option: item.Option4 },
                ],
                question: item.question,
                addedBy: user?._id,
            }
        })

        const resData = await dispatch(postData('/mcq-questions/bulk', payload))
        if (resData.code === 200) {
            setImportModel(false)
            reloadTable()
            setData([])
        }
    }

    const onDataSet = (data) => {
        setData(data)
    }

    return <>
        <CustomModal
            visible={importModel}
            title="Import MCQ Questions"
            onCancel={() => setImportModel(false)}
            footer={
                <Button type="primary" onClick={onSubmit}>Submit</Button>
            }
        >
            <ParseCsv onDataload={onDataSet} sampleData={sampleData} />
        </CustomModal>
        <CommonView componentConfig={componentConfig.componentConfig} config={componentConfig.config} />
    </>;
}

export default MCQQuestions;